import { a } from './chunk-EDSSKNZQ.mjs';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';

var n=class extends WalletConnectConnector{isAuthorized=async()=>a.getState().connectedConnectorId!==this.id?!1:super.isAuthorized()};function d(){if(typeof window>"u")return !1;let{ethereum:e}=window;return !!(e?.isCoinbaseWallet||e?.providers&&e?.providers.find(r=>r?.isCoinbaseWallet))}function l(){if(typeof window>"u")return !1;let{ethereum:e}=window;return !!e?.isCoinbaseBrowser}

export { d as a, l as b, n as c };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-3X7A75GE.mjs.map